import script from "./SupportButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportButton.vue?vue&type=script&setup=true&lang=js"

import "./SupportButton.vue?vue&type=style&index=0&id=0b49101a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b49101a"]])

export default __exports__